<template>
  <default-layout>
    <section slot="content">
      <template>
        <div>
          <template>
            <v-row justify="center">
              <v-col cols="12" md="12" xs="12">
                <v-expansion-panels multiple v-model="panel">
                  <v-expansion-panel>
                    <v-expansion-panel-header class="tile">
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <b>Registro de Compras</b>
                      </v-col>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row dense align="center" justify="center">
                        <v-col cols="12">
                          <v-card flat>
                            <v-card-title>
                              <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Ingresar texto a buscar"
                                single-line
                                hide-details
                              ></v-text-field>
                            </v-card-title>
                            <v-data-table
                              :headers="headers"
                              :items="items"
                              :search="search"
                            >
                              <template v-slot:header.orderNumber="{ header }">
                                NÚMERO PEDIDO<br>[PEDIDO ID - CLIENT ID]
                              </template>

                              <template v-slot:item.orderNumber="{ item }">
                                <v-btn
                                  small
                                  color="orange"
                                  dark
                                >
                                  {{ item.orderNumber }}
                                </v-btn>
                              </template>

                              <template v-slot:item.status="{ item }">
                                <v-btn
                                  x-small
                                  :color="getColorOrTextStatus(item.status, 'color')"
                                  dark
                                >
                                  {{ getColorOrTextStatus(item.status, 'text')  }}
                                </v-btn>

                              </template>

                              <template v-slot:item.actions="{ item }">
                                <v-btn
                                  depressed
                                  color="primary"
                                  @click="getDetail(item)"
                                >
                                  <v-icon dark>
                                    mdi-pencil
                                  </v-icon>
                                </v-btn>

                                <v-btn
                                  depressed
                                  color="accent"
                                  @click="getLabel(item)"
                                >
                                  <v-icon dark>
                                    delivery_dining
                                  </v-icon>
                                </v-btn>
                              </template>
                            </v-data-table>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>

              <v-dialog
                v-model="dialog"
                lg
              >
                <v-card>
                  <v-card-title class="primary dark">
                    <template>
                      <v-tabs
                          v-model="tab"
                          background-color="primary"
                          dark
                      >
                        <v-tab href="#tab-1">Datos de la Orden y Cliente</v-tab>
                        <v-tab href="#tab-2" :readonly="order.id ? false : true">Detalle de la Orden</v-tab>
                      </v-tabs>
                    </template>
                  </v-card-title>

                  <v-card-text>
                    <v-tabs-items v-model="tab">
                      <v-tab-item
                        key="1"
                        value="tab-1"
                      >
                        <v-card flat>
                          <v-card-text>
                            <template>
                              <v-form ref="form" v-model="valid">
                                <v-container fluid>
                                  <v-row justify="center">
                                    <v-expansion-panels v-model="panelOrder" popout multiple>
                                      <v-expansion-panel key="order" hide-actions>
                                        <v-expansion-panel-header>
                                          <v-row
                                            align="center"
                                            class="spacer"
                                            no-gutters
                                          >
                                            <v-col
                                              cols="4"
                                              sm="2"
                                              md="1"
                                            >
                                              <v-avatar size="36px">
                                                <v-icon color="red">storefront</v-icon>
                                              </v-avatar>
                                            </v-col>

                                            <v-col
                                              class="hidden-xs-only"
                                              sm="5"
                                              md="3"
                                            >
                                              <strong>DATOS DE LA ORDEN</strong>
                                            </v-col>
                                          </v-row>
                                        </v-expansion-panel-header>

                                        <v-expansion-panel-content>
                                          <v-divider></v-divider>
                                          <v-card-text>
                                            <v-container>
                                              <v-row>
                                                <v-col
                                                  cols="12"
                                                  md="4"
                                                >
                                                  <v-text-field
                                                    v-model="order.created_at"
                                                    label="Fecha de Pedido"
                                                    outlined
                                                    dense
                                                    readonly
                                                  ></v-text-field>
                                                </v-col>

                                                <v-col
                                                  cols="12"
                                                  md="4"
                                                >
                                                  <v-text-field
                                                    v-model="order.quantity"
                                                    label="Cantidad de Productos"
                                                    outlined
                                                    dense
                                                    readonly
                                                  ></v-text-field>
                                                </v-col>

                                                <v-col
                                                  cols="12"
                                                  md="4"
                                                >
                                                  <v-text-field
                                                    v-model="order.shipping_type_id"
                                                    label="Tipo de Envío"
                                                    outlined
                                                    dense
                                                    readonly
                                                  ></v-text-field>
                                                </v-col>

                                                <v-col
                                                  cols="12"
                                                  md="4"
                                                >
                                                  <v-text-field
                                                    v-model="order.shipping_price"
                                                    label="Total Delivery"
                                                    outlined
                                                    dense
                                                    readonly
                                                  ></v-text-field>
                                                </v-col>

                                                <v-col
                                                  cols="12"
                                                  md="4"
                                                >
                                                  <v-text-field
                                                    v-model="order.subtotal"
                                                    label="Subtotal"
                                                    outlined
                                                    dense
                                                    readonly
                                                  ></v-text-field>
                                                </v-col>

                                                <v-col
                                                  cols="12"
                                                  md="4"
                                                >
                                                  <v-text-field
                                                    v-model="order.coupon"
                                                    label="Cupón"
                                                    outlined
                                                    dense
                                                    readonly
                                                  ></v-text-field>
                                                </v-col>

                                                <v-col
                                                  cols="12"
                                                  md="4"
                                                >
                                                  <v-text-field
                                                    v-model="order.total"
                                                    label="Total"
                                                    outlined
                                                    dense
                                                    readonly
                                                  ></v-text-field>
                                                </v-col>

                                                <v-col
                                                  cols="12"
                                                  md="4"
                                                >
                                                  <v-text-field
                                                    v-model="order.delivery_day"
                                                    label="Fecha de Delivery"
                                                    outlined
                                                    dense
                                                    readonly
                                                  ></v-text-field>
                                                </v-col>

                                                <v-col
                                                  cols="12"
                                                  md="4"
                                                >
                                                  <v-text-field
                                                    v-model="order.delivery_partner"
                                                    label="Delivery Partner"
                                                    outlined
                                                    dense
                                                  ></v-text-field>
                                                </v-col>

                                                <v-col
                                                  cols="12"
                                                  md="4"
                                                >
                                                  <v-btn
                                                    color="primary"
                                                    block
                                                    depressed
                                                    @click="updateDeliveryPartner()"
                                                  >
                                                    ACTUALIZAR PARTNER
                                                  </v-btn>
                                                </v-col>
                                              </v-row>
                                            </v-container>
                                          </v-card-text>
                                        </v-expansion-panel-content>
                                      </v-expansion-panel>

                                      <v-expansion-panel key="client" hide-actions>
                                        <v-expansion-panel-header>
                                          <v-row
                                            align="center"
                                            class="spacer"
                                            no-gutters
                                          >
                                            <v-col
                                              cols="4"
                                              sm="2"
                                              md="1"
                                            >
                                              <v-avatar size="36px">
                                                <v-icon color="red">contact_mail</v-icon>
                                              </v-avatar>
                                            </v-col>

                                            <v-col
                                              class="hidden-xs-only"
                                              sm="5"
                                              md="3"
                                            >
                                              <strong>INFORMACIÓN DEL CLIENTE</strong>
                                            </v-col>
                                          </v-row>
                                        </v-expansion-panel-header>

                                        <v-expansion-panel-content>
                                          <v-divider></v-divider>
                                          <v-card-text>
                                            <v-container>
                                              <v-row>
                                                <v-col
                                                  cols="12"
                                                  md="12"
                                                >
                                                  <v-text-field
                                                    v-model="client.names"
                                                    label="Nombre y Apellidos"
                                                    outlined
                                                    dense
                                                    readonly
                                                  ></v-text-field>
                                                </v-col>

                                                <v-col
                                                  cols="12"
                                                  md="5"
                                                >
                                                  <v-text-field
                                                    v-model="client.phone"
                                                    label="Número de Celular"
                                                    outlined
                                                    dense
                                                    readonly
                                                  ></v-text-field>
                                                </v-col>

                                                <v-col
                                                  cols="12"
                                                  md="7"
                                                >
                                                  <v-text-field
                                                    v-model="client.email"
                                                    label="Email"
                                                    outlined
                                                    dense
                                                    readonly
                                                  ></v-text-field>
                                                </v-col>
                                              </v-row>
                                            </v-container>
                                          </v-card-text>
                                        </v-expansion-panel-content>
                                      </v-expansion-panel>

                                      <v-expansion-panel key="address" hide-actions>
                                        <v-expansion-panel-header>
                                          <v-row
                                            align="center"
                                            class="spacer"
                                            no-gutters
                                          >
                                            <v-col
                                              cols="4"
                                              sm="2"
                                              md="1"
                                            >
                                              <v-avatar size="36px">
                                                <v-icon color="red">assistant_direction</v-icon>
                                              </v-avatar>
                                            </v-col>

                                            <v-col
                                              class="hidden-xs-only"
                                              sm="5"
                                              md="3"
                                            >
                                              <strong>DIRECCIÓN DEL CLIENTE</strong>
                                            </v-col>
                                          </v-row>
                                        </v-expansion-panel-header>

                                        <v-expansion-panel-content>
                                          <v-divider></v-divider>
                                          <v-card-text>
                                            <v-container>
                                              <v-row>
                                                <v-col
                                                  cols="12"
                                                  md="12"
                                                >
                                                  <v-text-field
                                                    v-model="address.address"
                                                    label="Dirección"
                                                    outlined
                                                    dense
                                                    readonly
                                                  ></v-text-field>
                                                </v-col>

                                                <v-col
                                                  cols="12"
                                                  md="12"
                                                >
                                                  <v-text-field
                                                    v-model="address.reference"
                                                    label="Referencia"
                                                    outlined
                                                    dense
                                                    readonly
                                                  ></v-text-field>
                                                </v-col>
                                              </v-row>
                                            </v-container>
                                          </v-card-text>
                                        </v-expansion-panel-content>
                                      </v-expansion-panel>
                                    </v-expansion-panels>

                                    <v-col
                                      cols="12"
                                      md="4"
                                      offset-md="8"
                                    >
                                      <v-btn
                                        :readonly="!valid"
                                        color="primary"
                                        block
                                        depressed
                                        @click="updateStatusOrder(order.id, order.status)"
                                      >
                                        {{ order.status == 1 ? 'ANULAR' : 'REVERTIR ANULACIÓN' }}
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-form>
                            </template>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                      <v-tab-item
                        key="2"
                        value="tab-2"
                      >
                        <v-card flat>
                          <v-card-text>
                            <template>
                              <v-row dense align="center" justify="center">
                                <v-col cols="10">
                                  <v-data-table
                                    :headers="ODHeaders"
                                    :items="ODItems"
                                  >
                                  </v-data-table>
                                </v-col>
                              </v-row>
                            </template>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="adm_orange"
                      text
                      @click="dialog = false"
                    >
                      Cerrar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

            </v-row>
          </template>
        </div>
      </template>

      <template>
        <div class="text-center">
          <v-dialog
            v-model="dialogLabel"
            lg
          >
            <v-card>
              <v-card-title class="primary dark"></v-card-title>
              <v-card-text>
                <v-row class="mt-1">
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-textarea
                      rows="1"
                      auto-grow
                      outlined
                      name="input-7-4"
                      label="Descripcion"
                      :value="labelDetail"
                      readonly
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  text
                  @click="dialogLabel = false"
                >
                  Cerrar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </template>

      <template>
        <div class="text-center ma-2">
          <v-snackbar
            v-model="snackbar"
            :color="color"
            top
            z-index="500"
          >
            {{ text }}
            <template v-slot:action="{ attrs }">
              <v-btn
                color="white"
                text
                v-bind="attrs"
                @click="snackbar = false"
              >
                X
              </v-btn>
            </template>
          </v-snackbar>
        </div>
      </template>

      <template>
        <div class="text-center">
          <v-overlay :value="overlay" z-index="500">
            <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="primary"
            ></v-progress-circular>
          </v-overlay>
        </div>
      </template>

    </section>
  </default-layout>
</template>
<script>
  import DefaultLayout from '@/layouts/DefaultLayout'
  import axios from 'axios'
  import moment from 'moment'
  import {
    formatOrderList,
  } from '@/utils/order/index'

  axios.defaults.baseURL = process.env.DINO.ENDPOINT;

  moment.locale('es');

  export default {
    name: 'ProductView',
    components: {
      DefaultLayout
    },
    data () {
      return {
        overlay: false,
        dialog: false,
        dialogLabel: false,
        tab: null,
        panel: [0],
        panelOrder: [0],
        active: null,
        modal: false,
        date: moment().toISOString().substr(0, 10),
        search: '',
        headers: [
          { text: 'NÚMERO PEDIDO', value: 'orderNumber', align: 'center', sortable: false},
          { text: 'CELULAR', value: 'phone'},
          { text: 'CLIENTE', value: 'full_name'},
          { text: 'FECHA DE PEDIDO', value: 'created_at' },
          { text: 'TOTAL DELIVERY', value: 'shipping_price' },
          { text: 'SUBTOTAL', value: 'subtotal' },
          { text: 'CUPÓN', value: 'coupon' },
          { text: 'TOTAL', value: 'total' },
          { text: 'FECHA DE DELIVERY', value: 'delivery_day' },
          { text: 'DELIVERY PARTNER', value: 'delivery_partner' },
          { text: 'ESTADO', value: 'status' },
          { text: 'ACCIONES', value: 'actions', filterable: false, sortable: false }
        ],
        items: [],
        valid: true,
        order: {
          id: null,
          delivery_day: null,
          quantity: null,
          shipping_type_id: null,
          shipping_price: null,
          subtotal: null,
          coupon: null,
          total: null,
          created_at: null,
          status: null,
          delivery_partner: null
        },
        client: {
          names: null,
          name: null,
          last_name: null,
          phone: null,
          email: null
        },
        address: {
          address: null,
          reference: null
        },
        ODHeaders: [
          { text: 'GRUPO', value: 'product.group', width: '20%' },
          { text: 'PRODUCTO', value: 'product.name', width: '30%' },
          { text: 'UNIDADES', value: 'quantity', width: '10%' },
          { text: 'PRECIO UNITARIO', value: 'unit_price', width: '20%' },
          { text: 'TOTAL', value: 'amount', width: '20%' }
        ],
        ODItems: [],
        labelDetail: null,
        // ************ snackbar ************
        snackbar: false,
        text: '',
        color: 'green',
        // **********************************
      }
    },
    methods: {
      showMessage(text, color) {
        this.snackbar = true;
        this.text = text;
        this.color = color;
      },

      zfill: function(number, width) {
        var numberOutput = Math.abs(number);
        var length = number.toString().length;
        var zero = "0";

        if (width <= length) {
          if (number < 0) {
            return ("-" + numberOutput.toString());
          } else {
            return numberOutput.toString();
          }
        } else {
          if (number < 0) {
            return ("-" + (zero.repeat(width - length)) + numberOutput.toString());
          } else {
            return ((zero.repeat(width - length)) + numberOutput.toString());
          }
        }
      },

      getOrderNumber: function(orderId, clientId) {
        return this.zfill(orderId, 9) + '-' + clientId.toString();
      },

      formatDate: function(date) {
        return moment(date).format("DD/MM/yyyy");
      },

      formatDateTime: function(dateTime) {
        return moment(dateTime).format("DD/MM/yyyy HH:mm:ss");
      },

      getOrdersPlaced() {
        this.overlay = true;
        axios.get(process.env.DINO.PATH.GET_ORDERS)
        .then(response => {
          this.items = formatOrderList(response.data);
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      getColorOrTextStatus(status, type) {
        let value = '';

        if (type === 'color') {
          value = status == 1 ? 'green' : 'error';
        } else if (type === 'text') {
          value = status == 1 ? 'PROCESADO' : "ANULADO";
        }

        return value;
      },

      cleanForm() {
        this.$refs.form.reset();
      },

      getDetail(item) {
        this.overlay = true;
        axios.all([
          axios.get(process.env.DINO.PATH.GET_CLIENT.replace(':client_id', item.client_id)),
          axios.get(process.env.DINO.PATH.GET_ADDRESS.replace(':address_id', item.address_id))
        ])
        .then(response => {
          this.order.id = item.id;
          this.order.created_at = this.formatDateTime(item.created_at_original);
          this.order.quantity = item.quantity;
          this.order.shipping_type_id = item.shipping_type_id;
          this.order.shipping_price = item.shipping_price;
          this.order.subtotal = item.subtotal;
          this.order.coupon = item.coupon ? `-${ item.coupon }` : '';
          this.order.total = item.total;
          this.order.status = item.status;
          this.order.delivery_day = this.formatDate(item.delivery_day_original);
          this.order.delivery_partner = item.delivery_partner;
          this.ODItems = item.order_detail;
          this.client.names = response[0].data.name + ' ' + response[0].data.last_name;
          this.client.name = response[0].data.name;
          this.client.last_name = response[0].data.last_name;
          this.client.phone = response[0].data.phone;
          this.client.email = response[0].data.email;
          this.address.address = response[1].data.address;
          this.address.reference = response[1].data.reference;
          this.dialog = true;
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      getLabel(item) {
        this.overlay = true;
        axios.all([
          axios.get(process.env.DINO.PATH.GET_CLIENT.replace(':client_id', item.client_id)),
          axios.get(process.env.DINO.PATH.GET_ADDRESS.replace(':address_id', item.address_id))
        ])
        .then(response => {
          this.client.names = (response[0].data.name ? response[0].data.name : '') + 
          ' ' + 
          (response[0].data.last_name ? response[0].data.last_name : '');

          const name = item.person_reception == 1 ? this.client.names : `${item.name_reception} ${item.last_name_reception}`
          const saldo = item.total;
          const identificador = this.getOrderNumber(item.id, item.client_id);

          this.labelDetail = `DINO TOYS

NOMBRE: ${name}
DISTRITO: ${response[1].data.district ? response[1].data.district.name : ''}
DIRECCIÓN: ${response[1].data.address}
NUMERO: ${response[0].data.phone}
SALDO: ${saldo}
IDENTIFICADOR: ${identificador}`;

          this.dialogLabel = true;
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      updateStatusOrder(orderId, status) {
        this.overlay = true;
        axios.post(process.env.DINO.PATH.UPDATE_STATUS_ORDER, { 'order_id': orderId, 'status': status })
        .then(response => {
          this.getOrdersPlaced();
          this.showMessage(response.data.message, 'green');
          this.dialog = false;
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      updateDeliveryPartner() {
        this.overlay = true;
        axios.post(process.env.DINO.PATH.UPDATE_DELIVERY_PARTNER, { 'order_id': this.order.id, 'delivery_partner': this.order.delivery_partner })
        .then(response => {
          this.getOrdersPlaced();
          this.showMessage(response.data.message, 'green');
          this.dialog = false;
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      }

    },

    mounted: function () {
      axios.defaults.headers = {
        'authorization': localStorage.getItem('authorization')
      };

      this.getOrdersPlaced();
    },
    watch: {
      dialog (val) {
        if (val === false) {
          this.cleanForm();
          this.active = null;
          this.tab = 'tab-1';
          this.panelOrder = [0];
        }
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/order/Order.vue